import { render } from "./HandymanHeaderNotifications.vue?vue&type=template&id=2b8c6b96"
import script from "./HandymanHeaderNotifications.vue?vue&type=script&lang=js"
export * from "./HandymanHeaderNotifications.vue?vue&type=script&lang=js"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__